import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'position',
  standalone: true
})
export class PositionPipe implements PipeTransform {

  transform(value: number): string {
   switch (value) {
    case 1:
      return "Goalkeeper"
      break;

      case 2:
      return "Defender"
      break;  
   
    default:
      return "Forward"
      break;
   }
  }

}
